import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import { useTheme } from '../lib/theme.js';
import { Icon } from './Icon.js';

export function TopBar(): JSX.Element {
  const navigate = useNavigate();
  const { theme, toggle } = useTheme();
  const { data: accounts } = useQuery({ queryKey: ['accounts'], queryFn: api.accounts });
  const { data: me } = useQuery({ queryKey: ['me'], queryFn: () => api.me() });

  const connected = accounts?.filter((a) => a.status === 'connected').length ?? 0;

  return (
    <div className="topbar">
      <button className="tenant" type="button">
        <span className="dot" />
        {me?.tenant.name || 'החשבון שלי'}
        <Icon name="chevronDown" />
      </button>
      <div className="spacer" />
      <div className="heartbeat">
        <span className="pulse" /> {connected} מספרים מחוברים
      </div>
      <button className="btn sheen-host sheen-once sheen-hover" type="button" onClick={() => navigate('/composer')}>
        <Icon name="send" /> שלח עכשיו
      </button>
      <button className="icon-btn" type="button" onClick={toggle} title="החלף מצב תצוגה" aria-label="החלף מצב תצוגה">
        <Icon name={theme === 'dark' ? 'sun' : 'moon'} />
      </button>
    </div>
  );
}
